const transitionsRaw = {
  default: 330,
  fast: 100,
  medium: 250,
  slow: 660
};
const transitionsMs = {
  default: "".concat(transitionsRaw.default, "ms"),
  fast: "".concat(transitionsRaw.fast, "ms"),
  medium: "".concat(transitionsRaw.medium, "ms"),
  slow: "".concat(transitionsRaw.slow, "ms")
};
const transitions = {
  transitions: transitionsRaw,
  transitionsMs
};

export { transitions };
